import React, {  useState } from "react";

export default function Checkboxes({ label, questionId, answers, selectedAnswers, onChange }) {
    const [selected, setSelected] = useState(selectedAnswers ?? []);

    const handleChange = $box => {
        let current = [...selected];
        let id = +$box.value;
        let selectedOnChange = $box.checked ? [...current, id] : current.filter(answerId => answerId !== id);
             
        setSelected(selectedOnChange);
        onChange(questionId, selectedOnChange);
    };

    return (
        <div className="checkbox-group">
            <div className="question-label">{label}</div>
            <div className="checkbox-wrap">
                {
                    answers.map(answer => {
                        return (
                            <Checkbox
                                key={answer.AnswerId}
                                id={questionId}
                                label={answer.AnswerText}
                                value={answer.AnswerId}
                                checked={selected && selected.includes(answer.AnswerId)}
                                onChange={handleChange}
                            />
                        );
                    })
                }
            </div>
        </div>
    );
}

function Checkbox({ id, label, value, checked, children, onChange }) {
    return (
        <label className="checkbox" htmlFor={`checkbox-${value}`}>
            {checked && (
                <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width={32} height={32} ><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
            )}

            {!checked && (
                <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width={32} height={32} > <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" /> </svg>
            )}

            <input type="checkbox"
                id={`checkbox-${value}`}
                name={id}
                value={value}
                checked={checked}
                onChange={(e) => onChange(e.target)}
            />

            {typeof label === 'string' ? label : children}
        </label>
    );
}
